import Address from "./models/Address"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const saveAddress = (testEventId: number, address: Address) => ObservableFromFetch<void>(`Results/UpdateAddress?testEventId=${testEventId}`, JSON.stringify(address))
